import React from 'react';
import WalkingIcon from '@material-ui/icons/DirectionsWalkRounded';
import CarIcon from '@material-ui/icons/DirectionsCarRounded';
import PersonIcon from '@material-ui/icons/PersonRounded';
import Typography from '@material-ui/core/Typography';

import { user } from '../../../constants';

const styles = {
  root: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    transform: 'translate(-50%, -100%)'
  },
  icon: {
    color: 'white'
  },
  bubble: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    padding: 4,
  },
  textContainer: {
    justifyContent: 'center',
    marginLeft: 4,
    whiteSpace: 'nowrap'
  },
  name: {
    fontSize: 10,
    color: 'white',
  },
  timeAgo: {
    fontSize: 10,
    color: 'white'
  },
  downArrow: {
    position: 'relative',
    alignSelf: 'center',
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
  },
};

const UserMarker = ({ status, color, displayName, timeString, onClick }) => {
  let icon;

  switch(status) {
    case user.status.WALKING:
    case user.status.RUNNING:
      icon = <WalkingIcon style={styles.icon}/>;
      break;
    case user.status.DRIVING:
      icon = <CarIcon style={styles.icon}/>;
      break;
    default:
      icon = <PersonIcon style={styles.icon}/>;
  }

  return (
    <div style={styles.root} onClick={onClick}>
      <div style={{ ...styles.bubble, backgroundColor: color }}>
        {icon && (
          <div style={styles.iconContainer}>
            { icon }
          </div>
        )}
        <div style={styles.textContainer}>
          <Typography style={styles.name} variant='subtitle2'>{displayName}</Typography>
          <Typography style={styles.name} variant='caption'>{timeString}</Typography>
        </div>
      </div>
      <div style={{ ...styles.downArrow, borderTop: `8px solid ${color}` }} />
    </div>
    
  )
};



export default UserMarker;